function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M690 1382 l0 -828 184 -102 c101 -56 187 -102 191 -102 5 0 217 120 472 267 l463 267 0 212 0 211 -232 83 c-128 45 -316 111 -417 147 -100 35 -185 63 -186 61 -2 -2 33 -95 78 -207 l83 -204 121 -56 c67 -31 119 -59 115 -63 -4 -3 -116 -69 -249 -146 l-243 -140 0 648 c0 608 -1 648 -17 655 -30 12 -355 125 -359 125 -2 0 -4 -373 -4 -828z"
}));

const SvgBingads = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "256.000000pt",
  height: "256.000000pt",
  viewBox: "0 0 256.000000 256.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBingads, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bingads.e0f72c80.svg";
export { ForwardRef as ReactComponent };